import { VF_INPUT } from 'AppSrc/core/components/forms/form-base-components/v-f-input';

const fieldId = 'pou';

const initialValues = '';

const vFParams = {
  fieldTitle: 'POU ID',
  placeholder: '',
};

const validator = () => null; // this is only ever used as a readonly

const pou = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_INPUT,
};

export { pou };
